import type { Profile } from "./profile"

export interface Button {
	label: string
}

export enum AlertType {
	Error = 'error',
	Warning = 'warning',
	Success = 'success',
}

export enum ResourceType {
	PRODUCT = 'PRODUCT',
	FORUM = 'FORUM',
	FORUM_POST = 'FORUM_POST',
	FORUM_POST_COMMENT = 'FORUM_POST_COMMENT',
	CHALLENGE = 'CHALLENGE',
	MEETUP = 'MEETUP',
	USER = 'USER',
	MAGAZINE = 'MAGAZINE',
	MAGAZINE_COMMENT = 'MAGAZINE_COMMENT',
}

export enum ActivityType {
	SUBSCRIPTION = 'SUBSCRIPTION',
	FORUM_POST = 'FORUM_POST',
	MAGAZINE_ARTICLE = 'MAGAZINE_ARTICLE',
}

export interface Breadcrumb {
	handle?: string
	name: string
}

export enum SocialType {
	YOUTUBE = 'YOUTUBE',
	FACEBOOK = 'FACEBOOK',
	INSTAGRAM = 'INSTAGRAM',
	WECHAT = 'WECHAT',
	REDDIT = 'REDDIT',
	TIKTOK = 'TIKTOK',
	X = 'X',
	TELEGRAM = 'TELEGRAM',
	VIBER = 'VIBER',
	SNAPCHAT = 'SNAPCHAT',
	QUORA = 'QUORA',
	PINTEREST = 'PINTEREST',
	LINKEDIN = 'LINKEDIN',
	VIMEO = 'VIMEO',
	THREADS = 'THREADS',
	DISCORD = 'DISCORD',
	TWITCH = 'TWITCH',
	MEDIUM = 'MEDIUM',
	OTHER = 'OTHER',
}

export interface Social {
	id: number
	product_id?: number // used in product_socials table
	user_id: number
	type: SocialType
	url: string
	created_at: Date
	updated_at: Date
}

export interface TeamMember {
	name: string;
	role: string;
	username?: string;
	image?: string;
	user?: Profile | undefined | null;
}
